/* jshint esversion: 6 */
import React, { useState, useEffect } from 'react';
import {
    createBrowserRouter,
    createRoutesFromElements,
    RouterProvider,
    useLocation
} from 'react-router-dom';

export default function CommonRouter(props) {
    let router = createBrowserRouter(
        createRoutesFromElements(props.routes)
    );

    return (
        <RouterProvider router={router}/>
    );

}
